import axios from 'axios';
import config from '../../config';
import { STORAGE_KEYS } from '../../utils/constants';

export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGIN_RESET = 'LOGIN_RESET';
export const LOGOUT = 'LOGOUT';
export const SET_USER = 'SET_USER';
export const INITIALIZE_AUTH = 'INITIALIZE_AUTH';

export const login = (params) => {
  return {
    type: LOGIN,
    params,
  };
};

export const loginSuccess = (response) => {
  return {
    type: LOGIN_SUCCESS,
    response,
  };
};

export const loginFail = (response) => {
  return {
    type: LOGIN_FAIL,
    response,
  };
};

export const loginReset = () => {
  return {
    type: LOGIN_RESET,
  };
};

export const logout = () => {
  return {
    type: LOGOUT,
  };
};

export const setUser = (user) => {
  return {
    type: SET_USER,
    user,
  };
};

export const initializeAuth = () => {
  return {
    type: INITIALIZE_AUTH,
  };
};

export const loginApi = (data) => {
	return (dispatch) => {
		dispatch(login());
		axios
			.post(`${config.api.base_url}/auth/login`, data)
			.then((response) => {
				const loginData = response.data;
				dispatch(loginSuccess(loginData));
			})
			.catch((error) => {
				dispatch(loginFail(error.response?.data || { message: 'Login failed' }));
			});
	};
};

export const logoutApi = () => {
	return (dispatch) => {
		const token = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
		if (token) {
			axios
				.post(`${config.api.base_url}/auth/logout`, {}, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				.catch(() => {
					// Ignore errors on logout
				});
		}
		// Clear localStorage
		localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
		localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
		localStorage.removeItem(STORAGE_KEYS.USER_DATA);
		localStorage.removeItem(STORAGE_KEYS.PERMISSIONS);
		dispatch(logout());
	};
};

